import script from "./TrafficWorld.vue?vue&type=script&setup=true&lang=js"
export * from "./TrafficWorld.vue?vue&type=script&setup=true&lang=js"

import "./TrafficWorld.vue?vue&type=style&index=0&id=0460c812&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0460c812"]])

export default __exports__